module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_5@2x-c2b3223f6e9deae292d39b6343e03c0f.jpg";